import { gql } from "urql";

export const GET_LOAN_BY_OWNER: any = gql(`
    query GetLoanByOwner{
        GetLoanByOwner {
          loans {
            _id
            name
            type
            purpose
            ltv
            state
            userCreator {
                _id
                name
                lastName
            }
            onboarding
            investmentExperience
            loanData
            salesforceData
            owner {
                _id
                name
            }
          }
        }  
    }
`)

export const GET_LOAN_BY_ID: any = gql(`
    query GetLoanById($id: String!){
        GetLoanById(id: $id) {
            _id
            name
        }  
    }
`)

export const GET_LOANS_BY_OWNER: any = gql(`
    query GetLoansByOwner($search: String, $loanState: String, $page: Int, $limit: Int, $includeLoanDocs: Boolean){
        GetLoansByOwner(search: $search, loanState: $loanState, page: $page, limit: $limit, includeLoanDocs: $includeLoanDocs) {
          loans {
            _id
            name
            type
            purpose
            ltv
            progress
            state
            userCreator {
                _id
                name
                lastName
            }
            onboarding
            investmentExperience
            salesforceData
            tasks {
                _id
                name
                key
                state
                phase
                hidden
                metadata
            }
            loanDocs {
              _id
              key
              name
              description
              expiration
              state
              hidden
              isDeleted
              file {
                key
                name
                url
              }
              files {
                key
                name
                url
              }
            }
          }
          totalCount
          totalLoans
          hasMore
          currentPage
          tabTotals {
            all
            error
          }
        }  
    }
`)

export const GET_LOAN_DOCUMENTS: any = gql(`
    query GetLoanDocByLoan($loanId: String!){
        GetLoanDocByLoan(loanId: $loanId) {
            _id
            key
            name
            description
            expiration
            state
            hidden
            isDeleted
            file {
                key
                name
                url
            }
            files {
              key
              name
              url
            }
        }  
    }
`)

export const GET_LOAN_CLOSED_BY_LOAN: any = gql(`
    query GetLoansClosed($loanId: String!){
        GetLoansClosed(loanId: $loanId) {
            _id
            state
            createdAt
        }  
    }
`)